import { Box, Chip, Stack } from "@mui/material";
import { ReactNode } from "react";

export interface ImageComparisonLabelsProps {
  isVisible: boolean;
  beforeLabel?: ReactNode;
  afterLabel?: ReactNode;
}

export default function ImageComparisonLabels({
  isVisible,
  beforeLabel,
  afterLabel,
}: ImageComparisonLabelsProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{
        position: "absolute",
        top: 8,
        left: 8,
        right: 8,
        zIndex: 3,
        pointerEvents: "none",
        justifyContent: "space-between",
      }}
    >
      <Box>
        {beforeLabel && (
          <Chip
            label={beforeLabel}
            size='small'
            sx={{
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "white",
            }}
          />
        )}
      </Box>
      <Box>
        {afterLabel && (
          <Chip
            label={afterLabel}
            size='small'
            sx={{
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "white",
            }}
          />
        )}
      </Box>
    </Stack>
  );
}
